import { GET_DELIVERY_RATES, GET_DELIVERY_RATES_ERR, SET_DELIVERY_RATES } from '../actions/delivery/type';

const initState = {
  deliveryRates: [],
  loading: false,
  error: null,
  // Computed values for backward compatibility
  deliveryCost: 55,
  deliveryThreshold: 499
};

export default function (state = initState, action) {
  switch (action.type) {
    case GET_DELIVERY_RATES:
      return { ...state, loading: true, error: null };

    case SET_DELIVERY_RATES:
      const deliveryRates = action.payload;

      // Compute default values for backward compatibility
      const baseRate = deliveryRates.find(rate => rate.active && parseFloat(rate.min_spend) === 0);
      const freeDeliveryRate = deliveryRates.find(rate => rate.active && parseFloat(rate.rate) === 0);

      return {
        ...state,
        deliveryRates,
        loading: false,
        error: null,
        deliveryCost: baseRate ? parseFloat(baseRate.rate) : 55,
        deliveryThreshold: freeDeliveryRate ? parseFloat(freeDeliveryRate.min_spend) : 499
      };

    case GET_DELIVERY_RATES_ERR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        // Keep fallback values
        deliveryCost: 55,
        deliveryThreshold: 499
      };

    default:
      return state;
  }
} 